module.exports = __webpack_public_path__ + "static/img/industrial.87add3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/industrial.png
// module id = yD57
// module chunks = 0